var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#646D74",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    clipPath: "url(#upload_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.857 18v1.714a3.43 3.43 0 0 0 3.429 3.429h15.428a3.43 3.43 0 0 0 3.429-3.429V18M6.857 6.857l5.143-6 5.143 6M12 .857v15.429"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "upload_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgUpload;